import { pathRedirect } from '@/utils/auth'

import Collector from '@/containers/NB/Collector'
// import Repeater from '@/containers/TelnetReading/Repeater'
import DeviceInfo from '@/containers/NB/DeviceInfo'
import Counter from '@/containers/NB/counter'
import Area from '@/containers/NB/Area'
import PeriodSetting from '@/containers/NB/PeriodSetting'
import WaterList from '@/containers/NB/WaterList.vue'
import WateruserHistory from '@/containers/NB/WateruserHistory.vue'
import WaterUnused from '@/containers/NB/WaterUnused.vue'
import DataQuery from '@/containers/NB/DataQuery.vue'
import MonthAnalysis from '@/containers/NB/MonthAnalysis.vue'
import DataQueryHistory from '@/containers/NB/DataQueryHistory.vue'
import testMultSelect from '@/containers/NB/testMultSelect'
import WaterAllLists from '@/containers/NB/WaterAllLists'
import BillNum from '@/containers/NB/BillNum'
import subdistrictWaterStatistics from '@/containers/NB/subdistrictWaterStatistics'
import userWaterStatistics from '@/containers/NB/userWaterStatistics'
import waterStatisticsSummary from '@/containers/NB/waterStatisticsSummary'
import map from '@/containers/NB/counterMap'

export default {
  path: 'nb',
  redirect: pathRedirect,
  children: [
    { path: 'deviceInfo', component: DeviceInfo },
    { path: 'collector', component: Collector },
    { path: 'counter', component: Counter },
    { path: 'area', component: Area },
    { path: 'periodSetting', component: PeriodSetting },
    // { path: 'history', component: WateruserHistory, name: '用水历史' },
    { path: 'history/:counterId', component: WateruserHistory, name: '抄表历史' },
    { path: 'unusedHistory/:counterId', component: WateruserHistory, name: '无用水历史' },
    { path: 'waterList', component: WaterList },
    { path: 'waterUnused', component: WaterUnused },
    { path: 'monthAnalysis', component: MonthAnalysis },
    { path: 'dataQuery', component: DataQuery },
    { path: 'dataQueryHistory/:counterId', component: DataQueryHistory, name: '历史数据' },
    { path: 'waterAllLists', component: WaterAllLists },
    { path: 'waterAllHistory/:counterId', component: WateruserHistory, name: '抄表数据历史' },
    { path: 'billNum', component: BillNum, name: '抄表账单' },
    { path: 'test', component: testMultSelect },
    { path: 'sws', component: subdistrictWaterStatistics, name: '小区用水统计' },
    { path: 'uws', component: userWaterStatistics, name: '用户用水统计' },
    { path: 'wss', component: waterStatisticsSummary, name: '抄表总览' },
    { path: 'map', component: map, name: '设备地图' }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/nb.js